// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useLedgerApiClient } from '../../../contexts/LedgerApiContext';

export const useLedgerEnd = (): UseQueryResult<number, unknown> => {
  const ledgerApi = useLedgerApiClient();
  const ledgerEndQuery = useQuery({
    queryKey: ['getLedgerEnd'],
    queryFn: () => ledgerApi.api().getV2StateLedgerEnd(),
    select: (data) => data.offset,
  });
  return ledgerEndQuery;
};
